/**
 * @generated SignedSource<<015b78033934fec12415778e9179fecb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftHeaderLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftNav_viewer">;
  readonly " $fragmentType": "NftHeaderLayout_viewer";
};
export type NftHeaderLayout_viewer$key = {
  readonly " $data"?: NftHeaderLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeaderLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftHeaderLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8c400e0d2c6c7f0ef955e6293584492b";

export default node;
